"use client"

import React from "react"
import BaseNavigationLinks from "./BaseNavigationLinks"
import BrewKnowledgeNavigationLink from "./RootNavigationLinks/BrewKnowledgeNavigationLink"
import BrewMenuNavigationLink from "./RootNavigationLinks/BrewMenuNavigationLink"
import MarketMyBreweryNavigationLink from "./RootNavigationLinks/MarketMyBreweryNavigationLink"
import PerformancePlatformNavigationLink from "./RootNavigationLinks/PerformancePlatformNavigationLink"

export const RootNavigationLinks: React.FC<{
    showBaseLinks?: boolean
}> = ({ showBaseLinks }) => (
    <nav className='relative flex flex-col items-start justify-start w-full dark:text-gray-200'>
        {showBaseLinks && <BaseNavigationLinks />}
        <PerformancePlatformNavigationLink />
        <MarketMyBreweryNavigationLink />
        <BrewMenuNavigationLink />
        <BrewKnowledgeNavigationLink />
    </nav>
)

export default React.memo(RootNavigationLinks)
